import { styled } from "@mui/material";
import { NavLink } from "react-router-dom";

export const StyledLink = styled(NavLink)(({ theme }) => ({
    textDecoration: "none",
    fontSize: 20,
    fontWeight: 300,
    lineHeight: '100%',
    textTransform: 'capitalize',
    color: theme.palette.footer.link,
    transition: '0.5s',
    display: 'flex',          // غيّرنا إلى flex عشان النص والدائرة في صفّ واحد
    alignItems: 'center',     // لمحاذاة الدائرة مع النص عموديّاً
    margin: '8px 0',
    width: 'fit-content',
    '&:hover': {
        color: theme.palette.secondary.main,
        '& span': {
            borderColor: theme.palette.secondary.main,
            '&::after': {
                backgroundColor: theme.palette.secondary.main,
            }
        }
    },
}));